/* eslint-disable jsx-a11y/label-has-associated-control ,no-unsafe-optional-chaining */

import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import ImageUploader from 'components_newui/new_ui_image_uploader/ImageUploader1'
import FileUploader from 'components_newui/new_ui_file_uploader/View'
import { useFormContext,Controller } from 'react-hook-form';
import { FileUploaderFn } from 'pagesNewUi/post_idea/FileUploaderFn';


const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    basicDetailWrp:{
        margin: '1rem 0 2rem 0',
        padding: '1rem',
        background: '#fff'
    },
    title:{
        fontFamily: 'VodafoneRg-Regular', 
        fontSize: '1.25rem',
        margin: '0 0 2rem 0', 
        textAlign: 'left',
        color:"#333",
      },
    fieldsetBox:{
        marginBottom:theme.spacing(1),
        border: 0,
        padding: 0,
        background: 'transparent',
        '& label':{
            fontFamily: 'VodafoneRg-bold', 
            fontSize: '1rem',
            margin: '0 0 0.5rem 0', 
            textAlign: 'left',
            color:"#333",
            display:'block',
        },
        '& input[type="text"],input[type="date"],select ':{
            fontFamily: 'VodafoneRg-Regular', 
            fontSize: '1rem',
            margin: '0 0 0.5rem 0', 
            textAlign: 'left',
            color:"#333",
            background:'#fff',
            borderRadius:'4px',
            width: '100%',
            minHeight: '3rem',
            border: '1px solid #333',
            padding: '0.5rem',
            boxSizing: 'border-box',
        },
        '& select':{height:'48px'},
        '& input[type=date]:before':{content:'none'},
        '& textarea':{
            fontFamily: 'VodafoneRg-Regular', 
            fontSize: '1rem',
            margin: '0 0 0.5rem 0', 
            textAlign: 'left',
            color:"#333",
            background:'#fff',
            borderRadius:'4px',
            width: '100%',
            minHeight: '8.5rem',
            border: '1px solid #333',
            padding: '0.5rem',
            boxSizing: 'border-box',
            resize:'none'
        },
        
        
        
    },
    '& input[aria-invalid="true"]':{
        borderColor:'red',
    },
    error:{
        color:"red",
        fontFamily: 'VodafoneRg-Regular', 
        fontSize: '1rem',
        margin: '0 0 0.5rem 0', 
    },
    labelname:{
        fontFamily: 'VodafoneRg-bold', 
        fontSize: '1rem',
        margin: '0 0 0.5rem 0', 
        textAlign: 'left',
        color:"#333",
        display:'block',
    },
    
    invalid: {
        borderColor: 'red !important',
    },
    
    wrp2cols:{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '1rem'
    },
    backButton: {
      marginRight: theme.spacing(1),
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  }));
  
  
const marketTypes = [
    { "id": "Albania", "MarketName": "Albania" },
    { "id": "Czech Republic", "MarketName": "Czech Republic" },
    { "id": "DR Congo", "MarketName": "DR Congo" },
    { "id": "Egypt", "MarketName": "Egypt" },
    { "id": "Ethiopia", "MarketName": "Ethiopia" },
    { "id": "Germany", "MarketName": "Germany" },
    { "id": "Ghana", "MarketName": "Ghana" },
    { "id": "Greece", "MarketName": "Greece" },
    { "id": "IoT Nxt", "MarketName": "IoT Nxt" },
    { "id": "Ireland", "MarketName": "Ireland" },
    { "id": "Italy", "MarketName": "Italy" },
    { "id": "Kenya", "MarketName": "Kenya" },
    { "id": "Lesotho", "MarketName": "Lesotho" },
    { "id": "Luxembourg", "MarketName": "Luxembourg" },
    { "id": "Mezzanine", "MarketName": "Mezzanine" },
    { "id": "Mozambique", "MarketName": "Mozambique" },
    { "id": "Netherlands", "MarketName": "Netherlands" },
    { "id": "Nexio", "MarketName": "Nexio" },
    { "id": "Other", "MarketName": "Other" },
    { "id": "Portugal", "MarketName": "Portugal" },
    { "id": "Romania", "MarketName": "Romania" },
    { "id": "South Africa", "MarketName": "South Africa" },
    { "id": "Spain", "MarketName": "Spain" },
    { "id": "Tanzania", "MarketName": "Tanzania" },
    { "id": "Turkey", "MarketName": "Turkey" },
    { "id": "United Kingdom", "MarketName": "United Kingdom" },
    { "id": "VOIS", "MarketName": "VOIS" },
    { "id": "Vodacom Group", "MarketName": "Vodacom Group" },
    { "id": "Vodafone Group", "MarketName": "Vodafone Group" },
    { "id": "X-Link", "MarketName": "X-Link" }
  ]
  


const businessUnitTypes = [
    { "id": "Consumer", "DivisionName": "Consumer" },
    { "id": "M-Pesa", "DivisionName": "M-Pesa" },
    { "id": "Customer Operations and Support", "DivisionName": "Customer Operations and Support" },
    { "id": "Enterprise", "DivisionName": "Enterprise" },
    { "id": "Financial and Digital Services", "DivisionName": "Financial and Digital Services" },
    { "id": "Other (e.g. Risk, Legal, HR, Subsidiaries)", "DivisionName": "Other (e.g. Risk, Legal, HR, Subsidiaries)" },
    { "id": "Technology", "DivisionName": "Technology" },
    { "id": "Vodacom Group", "DivisionName": "Vodacom Group" },
    { "id": "Vodafone Group", "DivisionName": "Vodafone Group" }
  ]

export const IdeaDetails = (props) => {
// console.log("🚀 ~ IdeaDetails edit idea ~ props:", props)

const { isAdmin,isEvaluator, isOwnerInnovate ,formData,deleteImageFn,postInnovateIdeaImageFn,onDocumentDelete,getInnovateIdeaIdDetail,deleteInnovateIdeaDocumentLoading,getInnovateIdeaDocumentUploadLoading,onDocumentUpload,getInnovateIdeaDocumentUpload=[],deleteInnovateIdeaDocument, getInnovateIdeaImageLoading , getInnovateIdeaImageDeleteLoading} = props || {}
const classes = useStyles();
const {ideaKey,documents:documentList=[] } = formData || {}
const {id:draftIdeaKey,status} = getInnovateIdeaIdDetail?.ideaForInnovater || {}
const { register, control,watch,formState: { errors } } = useFormContext();
// const updateddocumentList =   getInnovateIdeaDocumentUpload?.flat()
// const updateddocumentList = Array.isArray(getInnovateIdeaDocumentUpload)
//   ? documentList
//   : [];

// const listUploadedDocuments = [
//     ...documentList,
//     ...getInnovateIdeaDocumentUpload,
//   ];
  
//   const deduplicatedDocuments = Array.from(
//     new Map(listUploadedDocuments?.map(doc => [doc.key, doc]))?.values()
//   );
  

// const listUploadedDocuments = getInnovateIdeaDocumentUpload
// console.log("🚀 ~ IdeaDetails ~ listUploadedDocuments:", listUploadedDocuments,deduplicatedDocuments)
// const [documentData, setDocumentData] = useState([]);


// const allDocumentKey = getInnovateIdeaDocumentUpload?.map(file => {
//     // console.log("file..",file)
//      return file?.key
//   });

  return (
    <div className={classes.basicDetailWrp}>
       
        <h2 className={classes.title}>Basic Details</h2>
        <div className={classes.wrp2cols}>
            <fieldset className={classes.fieldsetBox}>
                <label htmlFor='market'> Select Your Market</label>
                <select
                    name="market"
                    id="market"
                    {...register('market')}
                    className={`${errors?.market ? classes.invalid : ''}`}
                >
                    <option value="">Select...</option>
                    {marketTypes.map(type => (
                        <option key={type.id} value={type.id}>
                            {type.MarketName}
                        </option>
                    ))}
                </select>

                {errors?.market?.message && <p className={classes.error}>{errors?.market?.message}</p>}
            </fieldset>
            <fieldset className={classes.fieldsetBox}>
                <label htmlFor='businessUnit'> Select Business Unit</label>
                <select
                    name="businessUnit"
                    id="businessUnit"
                    {...register('businessUnit')}
                    className={`${errors?.businessUnit ? classes.invalid : ''}`}
                >
                    <option value="">Select...</option>
                    {businessUnitTypes.map(type => (
                        <option key={type.DivisionName} value={type.id}>
                            {type.DivisionName}
                        </option>
                    ))}
                </select>

                {errors?.businessUnit?.message && <p className={classes.error}>{errors?.businessUnit?.message}</p>}
            </fieldset>
        </div>
        <fieldset className={classes.fieldsetBox}>
            <label htmlFor='title'>Idea Title</label>
            <input 
                type='text' 
                name="title" 
                id='title'  
                placeholder='Enter a descriptive title of your Idea ' 
                {...register('title')}
                className={` ${errors?.title ? classes.invalid: ''}`}
                aria-invalid={errors?.title ? "true" : "false"}
                disabled={status !== "DRAFT"}
            />
            {errors?.title?.message && <p className={classes.error}>{errors?.title?.message}</p>}
        </fieldset>
        <fieldset className={classes.fieldsetBox}>
            <label htmlFor='summary'>Idea Short Summary</label>
            <textarea  
                className={` ${errors?.summary ? classes.invalid: ''}`}
                name="summary" 
                id='summary'  
                placeholder='Describe the idea in a short summary' 
                {...register('summary')}
            />
            {errors?.summary?.message && <p className={classes.error}>{errors?.summary?.message}</p>}
        </fieldset>
       

        <div >
              <h3 className={classes.labelname}>Idea Cover Photo</h3>
              {/* <Controller
                  name="coverPhoto"
                  control={control}
                  rules={{ required: 'Idea cover photo is required' }}
                  render={({ field }) => (
                      <ImageUploader
                          images={field.value || []}
                          onSelectImage={(img) => field.onChange([img])}
                          deleteImage={() => field.onChange([])}
                          subtitle="Browse image"
                          imageUploadError=""
                          UploadLimit={1}
                          imagesLength={(field.value || []).length}
                      />
                  )}
              /> */}
              {/* <Controller
                  name="coverPhoto"
                  control={control}
                  rules={{ required: 'Idea cover photo is required' }}
                  render={({ field }) => (
                      <ImageUploader
                          classes={classes}
                          images={field.value || []}
                          onSelectImage={async (id, img) => {
                              // console.log("img-0-0-0-0-0-0-",id , img)
                              try {
                                  // const uploaded =
                                  await postInnovateIdeaImageFn(id, img);
                                  // if (uploaded?.url) {
                                  field.onChange([{ ...img, src: img?.src }]);
                                  // }
                              } catch (error) {
                                  console.error("Image upload failed", error);
                                  // Optionally show a user-friendly error message
                              }
                          }}
                          deleteImage={async (id, deletedImage) => {
                              await deleteImageFn(id, deletedImage);
                              field.onChange(null); // Clear the field if image is deleted
                          }}
                          isInnovateOneImageOnly
                          subtitle="Browse image"
                          isLoader={ getInnovateIdeaImageLoading || getInnovateIdeaImageDeleteLoading }
                          IdForImage={draftIdeaKey}
                      />
                  )}
              /> */}

              <Controller
                  name="coverPhoto"
                  control={control}
                  rules={{ required: 'Idea cover photo is required' }}
                  render={({ field }) => (
                      <ImageUploader
                          classes={classes}
                          images={field.value || []}
                          onSelectImage={async (id, img) => {
                            //   console.log("🚀 ~ async ~ idea edit img:", img)
                              const file = img?.file;

                              if (!file || typeof file.size !== 'number') {
                                  alert("Invalid file or file size not available.");
                                  return;
                              }

                              const fileSizeMB = file.size / (1024 * 1024);

                              if (Number.isNaN(fileSizeMB) || fileSizeMB > 10) {
                                  alert("Image size should be less than 10 MB");
                                  return;
                              }


                              try {
                                  await postInnovateIdeaImageFn(id, img);
                                  field.onChange([{ ...img, src: img?.src }]);
                              } catch (error) {
                                  console.error("Image upload failed", error);
                                  // Optionally show a user-friendly error message
                              }
                          }}
                          deleteImage={async (_id, deletedImage) => {
                              await deleteImageFn(draftIdeaKey, deletedImage);
                              field.onChange(null); // Clear the field if image is deleted
                          }}
                          isInnovateOneImageOnly
                          subtitle="Browse image"
                          isLoader={getInnovateIdeaImageLoading || getInnovateIdeaImageDeleteLoading}
                          IdForImage={draftIdeaKey}
                      />
                  )}
              />


              {errors?.coverPhoto?.message && <p className={classes.error}>{errors?.coverPhoto?.message}</p>}
          </div>

        <div >
            <h3 className={classes.labelname}>Document Support</h3>
              <Controller
                  name="documentsKey"
                  control={control}
                  rules={{ required: 'Idea Document Support required' }}
                  
                  render={({ field }) => (
                      <FileUploaderFn
                      isDocumentLoading={getInnovateIdeaDocumentUploadLoading || deleteInnovateIdeaDocumentLoading}
                      onDocumentUpload={onDocumentUpload}
                      IdeaIDKey={ ideaKey || undefined}
                      documentIdeaKey={
                        // listUploadedDocuments[0]?.key || undefined
                            Array.isArray(getInnovateIdeaDocumentUpload) && getInnovateIdeaDocumentUpload.length > 0
                            ? getInnovateIdeaDocumentUpload[0].key
                            : undefined
                    }
                      documents={getInnovateIdeaDocumentUpload}
                      onDocumentDelete={onDocumentDelete}
                      isInnovateDocuement
                      canDelete={isAdmin || isEvaluator || isOwnerInnovate }
                      isEvaluator={isEvaluator}
                      isAdmin={isAdmin}
                      isOwnerInnovate={isOwnerInnovate}
                      {...props} />

                    //   <FileUploader
                    //       images={field.value || []}
                    //       onSelectImage={(img) => field.onChange([img])}
                    //       deleteImage={() => field.onChange([])}
                    //       subtitle="Browse image"
                    //       imageUploadError=""
                    //       UploadLimit={1}
                    //       imagesLength={(field.value || []).length}
                    //   />

                  )}
              />
                {errors?.documentsKey?.message && <p className={classes.error}>{errors?.documentsKey?.message}</p>}
        </div>
        


    </div>
  )
}
